<template>

    <div class="pagination" v-if="this.totalPages > 1">
        <span class="prev"
              @click="prevPage"
              v-if="prevPageExist">
            <i class="fas fa-chevron-left"/>
        </span>
        <span class="current">
            {{ currentPage }}
        </span>
        <span class="next"
              @click="nextPage"
              v-if="nextPageExist">
            <i class="fas fa-chevron-right"/>
        </span>
    </div>

</template>

<script>

    export default {
        name: 'pagination',
        props: {
            currentPage: {
                type: Number,
                required: true
            },
            totalPages: {
                type: Number,
                required: true
            }
        },
        computed: {
            prevPageExist() {
                return this.currentPage > 1
            },
            nextPageExist() {
                return this.currentPage < this.totalPages
            }
        },
        methods: {
            prevPage() {
                this.$emit('reloadEvent', this.currentPage - 1 )
            },
            nextPage() {
                this.$emit('reloadEvent', this.currentPage + 1 )
            }
        }
    }

</script>

<style lang="scss" scoped>
    .pagination {
        text-align: center;

        .current {
            font-size: 1.8rem;
            font-weight: bold;
        }

        .prev, .next {
            cursor: pointer;
            padding: 0 5px;
        }
    }
</style>